













































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwCountryIcon } from '@libs-uuif/shared/sw-country-icon';
import { SelectOption, SwSelect } from '@libs-uuif/shared/sw-select';
import Component from 'vue-class-component';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { Prop } from 'vue-property-decorator';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { DropdownLight } from '@/shared/dropdown-light';

const cssPrefix = 'time-zone';
@Component({
  components: {
    SwCountryIcon,
    SwSelect,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwTextfield,
    DropdownLight,
  },
})
export default class TimeZone extends SwExtendedVue {
  cssPrefix = cssPrefix;
  display2 = true;
  @Prop({ required : true })
  timeZones : any;
  modalTitle = '';
  fieldNames = [];
  textDateValue = [];
  buttons = [];
  value1 = '';
  selectedValue = '';
  requiredField = [];
  showError : boolean = false;
  timeZoneOption :  SelectOption[] = [];
  created() {
    this.timeZones.forEach((ele : any) => {
      const inner : any = {};
      inner['id'] = ele.timeZone;
      inner['label'] = ele.timeZonetext;
      inner['value'] = ele.timeZonetext;
      this.timeZoneOption.push(inner);
    });
    this.selectedValue = this.timeZoneOption[0].id;
  }
  closeDialog(modalReponse: any = { refresh: false, timeZoneObj: {} }) {
    this.$emit('close-modal', modalReponse);
  }
  submit() {
    this.$emit('submit-zone', this.selectedValue);
    console.warn(this.selectedValue);
    const obj = {
      timeZone : this.selectedValue,
    };
    this.$store.dispatch('SnbProfileStoreModule/updateTimeZone', obj)
      .then((resp) => {
        if (resp.msgCode === 'MSWAPP:SUCCESS') {
          let timezoneObj:any = { refresh: false, timeZoneObj: {} };
          const ind = this.timeZones.findIndex((ele : any) => ele.timeZone === this.selectedValue);
          if (ind > -1) {
            const zoneName = this.timeZones[ind].timeZonetext.split(' ');
            let timeZoneNameTemp = '';
            zoneName.forEach((ele : any, ind: any) => {
              if (ind > 0) {
                timeZoneNameTemp += ele;
              }
            });
            const currentTime = resp.content.currnettimeZone.split(' ');
            timezoneObj = {
              name: timeZoneNameTemp,
              timeFormat: this.timeZones[ind].timeZonetext.split(' ')[0],
              currentTimePart1: currentTime[0],
              currentTimePart2: currentTime[1]?.toLowerCase(),
            };
          }
          const modalReponse = { refresh: true, timeZoneObj: timezoneObj };
          this.$emit('close-modal', modalReponse);
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
        }
      })
      .catch((err:any) => {
        console.error(err);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }
}
